import axios from "axios";
import React, { useEffect, useState } from "react";

export default function TopBar({ t }) {
  const localhost = process.env.REACT_APP_LOCALHOST;
  const [freeDeliveryThresholds, setFreeDeliveryThresholds] = useState(null);
  const [isThresholdsActive, setIsThresholdsActive] = useState(false);

  const fetchFreeDeliveryThresholds = async () => {
    try {
      const res = await axios.get(`${localhost}free-delivery-threshold`);
      const data = res.data?.data || res.data;

      if (data) {
        setFreeDeliveryThresholds(parseInt(data.minimum_amount));
        setIsThresholdsActive(data.is_delivery_thresholds_active);
      }
    } catch (err) {
      // console.error(err);
    }
  };

  useEffect(() => { fetchFreeDeliveryThresholds() }, []);

  if (isThresholdsActive) {
    return (
      <p className="flex h-9 uppercase items-center justify-center bg-black px-4 text-center text-xs sm:text-sm font-medium text-white sm:px-6 lg:px-8">
        {t("get-free-delivery", { price: `${freeDeliveryThresholds} MAD` })}
      </p>
    )
  };
}
